import { Controller } from '@hotwired/stimulus'

const NEAR_BOTTOM_PX = 200

export default class extends Controller {
  connect() {
    this.wasNearBottom = true
    this.scrollToBottom()
    this.onScroll = () => this.updateWasNearBottom()
    this.element.addEventListener('scroll', this.onScroll, { passive: true })
    this.observer = new MutationObserver(() => this.handleMutation())
    this.observer.observe(this.element, { childList: true, subtree: true, characterData: true })
  }

  disconnect() {
    this.observer?.disconnect()
    this.element.removeEventListener('scroll', this.onScroll)
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }

  updateWasNearBottom() {
    const distanceFromBottom = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight
    this.wasNearBottom = distanceFromBottom < NEAR_BOTTOM_PX
  }

  handleMutation() {
    if (this.wasNearBottom) this.scrollToBottom()
  }
}
